/**
 * FreeSpinsRetriggerView
 *
 * Handles the view functionality of the free spins dialog(s)
 */
(function () {
  class FreeSpinsRetrigger extends PIXI.Container {
    constructor() {
      super();

      this.visible = false;
      this._freeSpinsAwardedText = undefined;
      this._panel = undefined;
      this._darkOverlay = undefined;
      this._pressStartBox = undefined;
    }

    initialise() {
      messageBus.subscribe('spinner:GameConfigEvent', () => {
        this.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._freeSpinsAwardedText = resourceManager.get(
        'freeSpinsRetriggerContainer:FreeSpinsRetrigger:panel:freeSpinsAwarded'
      );
      this._panel = resourceManager.get('freeSpinsRetriggerContainer:FreeSpinsRetrigger:panel');
      this._darkOverlay = resourceManager.get('freeSpinsRetriggerContainer:FreeSpinsRetrigger:darkOverlay');
      this._pressStartBox = resourceManager.get('freeSpinsRetriggerContainer:FreeSpinsRetrigger:pressStartColourBox');

      this._darkOverlay.interactive = true; // stop being able to click on anything behind the panel
      this._pressStartBox.interactive = false;
    }

    async show(numFS, cbWhenPressed = null) {
      this._cbWhenPressed = cbWhenPressed;
      this._freeSpinsAwardedText.setTranslationParameters(numFS);
      this.visible = true;
      this._pressStartBox.interactive = false;

      soundManager.play('panelAppear');

      await game.tweenFromToAsync(
        this._panel.scale,
        {
          x: 0,
          y: 0,
        },
        {
          x: 1,
          y: 1,
          duration: 0.5,
          ease: 'bounce.out',
        }
      );

      let waitForInteractionResolver = null;
      const waitForInteractionPromise = new Promise((resolve) => {
        waitForInteractionResolver = resolve;
      });

      const pressedCB = () => {
        game.stopAutoClickForReplayRewatch();
        if (this._pressStartBox.interactive === true) {
          this._pressStartBox.interactive = false;
          waitForInteractionResolver();
          if (this._cbWhenPressed) {
            this._cbWhenPressed();
          }
        }
      };

      this._pressStartBox.mousedown = this._pressStartBox.touchstart = pressedCB;

      this._pressStartBox.interactive = true;
      game.autoClickForReplayRewatch(pressedCB);
      await waitForInteractionPromise;

      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = undefined;

      soundManager.play('panelRemove');

      await game.tweenFromToAsync(
        this._panel.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 0,
          y: 0,
          duration: 0.15,
          ease: 'none',
        }
      );

      this.visible = false;
    }
  }

  let create = function (json) {
    return new FreeSpinsRetrigger();
  };

  let initialise = function (json, container, resources) {
    container.initialise();
  };

  let getFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('FreeSpinsRetrigger', create, initialise, getFilesRequired);
})();
